import { useTikTok } from 'hooks/useTikTok';
import { useGoogleReCaptcha } from 'features/google-recaptcha';
import { useTrackPageViewed } from 'analytics/itly/hooks';
import { useTrackCheckoutStepViewed } from 'analytics/itly/hooks/useTrackCheckoutStepViewed';
import { Cart__Patched } from 'pages/checkout/cart';
import { TrackingProp } from 'react-tracking';
type TrackingHooksProps = {
  tracking: TrackingProp;
  entityId: number;
  cart: Cart__Patched;
};
export const TrackingHooksContainer = ({ tracking, entityId, cart }: TrackingHooksProps): null => {
  useTrackPageViewed(tracking, 'Checkout', 'Checkout Page');
  useTrackCheckoutStepViewed(tracking, entityId, 'review', cart);
  useGoogleReCaptcha({ pageType: 'Checkout', pageName: 'Checkout Page', action: 'checkout' });
  useTikTok({ event: 'PageView' });

  return null;
};